import React from 'react';
import LoadingSkeleton from 'components/LoadingSkeleton';

const Step3Skeleton = () => {
  return (
    <div className="mt-[4.2rem] flex flex-col gap-2 max-md:mt-[3.75rem]">
      <LoadingSkeleton count={3} height={16} className="mb-4" />
    </div>
  );
};

export default Step3Skeleton;
